import React from "react";

const PDFsContext = React.createContext(null);

export default PDFsContext;